import styled from 'styled-components'

export const StyledCloseButton = styled.button`
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  -ms-progress-appearance: none;
  background: none;
  display: inline;
`

export const StyledCloseImage = styled.img`
  width: 12px;
  height: 12px;
`
